export default __webpack_public_path__ + "static/media/Instagram-Icon.486061a6.png";